import { useLocalization } from 'Douleutaras/hooks/localization';
import { COUNTRY_CONFIG } from 'Douleutaras/constants/localization';

const countryCode = useLocalization().countryCode;
const vat = useLocalization().vatRegExp;

export const required = value => (value || typeof value === 'number' ? undefined : 'T.VALID.Required');

export const maxLength = max => value =>
  value && value.toString().length > max ? `Must be ${max} characters or less` : undefined;

export const minLength = min => value =>
  value && value.toString().length < min ? `Must be ${min} characters or more` : undefined;

export const minLength6 = minLength(6);
export const maxLength8 = maxLength(8);

export const numberValidator = value =>
  value && isNaN(Number(value)) ? 'Must be a number' : undefined;

export const minValue = min => value =>
  value && value < min ? `Must be at least ${min}` : undefined;

export const onlyPositive = minValue(1);

export const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

export const email = (value, error = undefined) =>
  value && !emailPattern.test(value)
    ? (error !== undefined ? error : 'T.VALID.Invalid email address')
    : undefined;

// validate if a string value contains multiple email addresses separated by commas
// example: testemail@gmail.com, testemail@gmail.com, testemail@gmail.com return true
export const multipleEmails = value =>
  value && !/^\s*(?:[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,})(?:\s*,\s*(?:[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}))*\s*$/i.test(value)
    ? 'T.VALID.Invalid email address'
    : undefined;

export const insuranceId = v => {
  let valid: boolean = true;
  let sum;
  if (v) {
    if (v.length !== 11 || !/^\d+$/.test(v)) {
      valid = false;
    } else {
      sum = parseInt(v[10], 10);
      let i = 0;
      const rtemp = v.slice(0, 10);
      while (i < rtemp.length) {
        const s = parseInt(rtemp[i], 10);
        if (i % 2 !== 0) {
          if (s * 2 > 9) {
            sum += s * 2 % 10 + 1;
          } else {
            sum += s * 2;
          }
        } else {
          sum += s;
        }
        i = i + 1;
      }
      valid = (sum % 10 === 0);
    }
  }

  // insuranceId not valid
  if (!valid) {
    return 'Invalid insurance ID number';
  }

  return undefined;
};

export const phoneNumber = value =>
  value && !COUNTRY_CONFIG.PHONE_REGEXP[countryCode].test(value)
    ? 'T.VALID.Invalid phone number, must be valid'
    : undefined;

export const landPhoneNumber = value =>
  value && !COUNTRY_CONFIG.LAND_PHONE_REGEXP[countryCode].test(value)
    ? 'T.VALID.Invalid phone number, must be valid'
    : undefined;

export const passwordsMatch = (value, allValues) =>
  value !== allValues.password1 ? 'Passwords don\'t match' : undefined;

export const pattern = exp => value =>
  value && !exp.test(value)
    ? 'T.VALID.Amount not allowed'
    : undefined;

export const vatPattern = pattern(vat);
export const floatPattern = pattern(/^[0-9]{1,9}((,|\.){1}([0-9]{1,9})?)?$/);
export const noLeadingZeroPattern = pattern(/^(0|[1-9][0-9]{0,7})((,|\.){1}([0-9]{1,9})?)?$/);
